import {
  ICustomFieldValueFormModel,
  validateCustomFields,
} from '@user/components/CustomFields'
import {
  ICustomFieldFormSetting,
  IEntityFormSetting,
} from '@user/store/entityFormSettings'
import { addLeadAddress } from '..'

export function setEntityAndCustomErrors(
  requiredEntitySettings: IEntityFormSetting[],
  model: ICustomFieldValueFormModel,
  errors,
  customFieldSettings: ICustomFieldFormSetting[],
) {
  requiredEntitySettings.forEach((element) => {
    if (
      (!model[element.fieldId] ||
        model[element.fieldId] == '' ||
        model[element.fieldId] == null) &&
      element.fieldId !== addLeadAddress
    )
      errors[element.fieldId] = 'Required'
  })

  errors = {
    ...errors,
    ...validateCustomFields(model, customFieldSettings),
  }
  return errors
}
